import React, { useEffect, useCallback } from 'react';
import { Box, Button, Text } from 'roo-ui/components';
import { useFailureState } from './useFailureState';
import { useDialog } from 'components/Dialog';
import { useDataLayer } from 'hooks/useDataLayer';
import ErrorHeading from 'pages/Checkout/BookingErrorDialogs/ErrorHeading';

const FailureDialog = () => {
  const { Dialog, openDialog, closeDialog } = useDialog();
  const { emitInteractionEvent } = useDataLayer();
  const failureState = useFailureState();

  const openDialogAndEmitEvent = useCallback(() => {
    openDialog();
    emitInteractionEvent(failureState.analyticsData);
  }, [openDialog, emitInteractionEvent, failureState]);

  useEffect(() => {
    if (failureState) openDialogAndEmitEvent();
    if (!failureState) closeDialog();
  }, [failureState, closeDialog, openDialogAndEmitEvent]);

  if (!failureState) return null;
  const { heading, body, bookingReference, isDismissible } = failureState;

  return (
    <Dialog>
      <ErrorHeading>{heading}</ErrorHeading>
      <Box mb={[6, 8]}>{body}</Box>
      {bookingReference && (
        <Box mb={[6, 8]}>
          <Text>Booking reference: {bookingReference}</Text>
        </Box>
      )}
      {isDismissible && (
        <Button variant="primary" width={['100%', 'auto']} onClick={closeDialog}>
          Close
        </Button>
      )}
    </Dialog>
  );
};

FailureDialog.displayName = 'FailureDialog';

export default FailureDialog;
